import { Fade, Popper, type PopperProps } from '@mui/material';
import type { ReactNode } from 'react';

type AnimatedPopperProps = Omit<PopperProps, 'children'> & {
  children?: ReactNode;
};

export function AnimatedPopper(props: AnimatedPopperProps) {
  const { children, ...other } = props;

  return (
    <Popper {...other} transition>
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={180}>
          <div>{children}</div>
        </Fade>
      )}
    </Popper>
  );
}
